/* eslint-disable camelcase */

// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import orderBy from 'lodash/orderBy';

import AlacarteStatusIndicator from 'components/AlacarteStatusIndicator';
import BookStatus from 'components/BookStatus';
import ExcerptItem from 'components/ExcerptItem';

// app modules: services
import assets from 'services/assets';
import route from 'services/route';

// assets
import CssAuthorFavourites from './AuthorFavourites.scss';

class AuthorFavourites extends Component {
  static propTypes = {
    recommendations: PropTypes.arrayOf(
      PropTypes.shape({
        comment: PropTypes.string,
        ranking: PropTypes.number,
        book: PropTypes.shape({
          authors: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string,
              first_name: PropTypes.string,
              last_name: PropTypes.string,
            }),
          ),
          image_name: PropTypes.string,
          isbn: PropTypes.string,
          ranking_recommendations: PropTypes.number,
          signature_: PropTypes.string,
          title: PropTypes.string,
        }),
      }),
    ).isRequired,
  };

  renderRecommendations() {
    const { recommendations } = this.props;

    return orderBy(recommendations, 'ranking').map(recommendation => {
      const {
        alacarte,
        alacarte_available,
        authors,
        image_name,
        isbn,
        ranking_recommendations,
        signature_,
        title,
        indexable,
        licensed,
      } = recommendation.book;

      const doNotDisplayStatusIcon = (!indexable && !licensed) || (alacarte && alacarte_available);

      return (
        <React.Fragment key={isbn}>
          {!doNotDisplayStatusIcon ? (
            <div className="authorFavourites__item__icon">
              <BookStatus statusType="small" book={recommendation.book} />
            </div>
          ) : null}
          <ExcerptItem
            allCapsTitle={false}
            key={isbn}
            title={title}
            description={recommendation.comment}
            link={route.book(isbn, signature_)}
            image={assets.coverUrl(image_name, {
              resize: 'fit-in',
              width: 315,
              height: 315,
            })}
            imageAdornements={
              alacarte ? (
                <AlacarteStatusIndicator
                  available={alacarte_available}
                  isbn={isbn}
                  signature_={signature_}
                  className="authorFavourites__alacarte-badge"
                />
              ) : null
            }
            imageProps={{
              ranking: ranking_recommendations,
            }}
            imageSize="small"
            authors={authors}
            truncateToFit={false}
            wrapAroundImage={false}
          />
        </React.Fragment>
      );
    });
  }

  render() {
    return <div>{this.renderRecommendations()}</div>;
  }
}

export default withStyles(CssAuthorFavourites)(AuthorFavourites);
